import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Icon from "../components/Icon";
import { Button, Field } from "../components/ui";
import { API, setToken } from "../api";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";
import { C, S } from "../theme";

export default function Join() {
  const { t: tr } = useI18n();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [params] = useSearchParams();
  const [code, setCode] = useState(params.get("code") || "");
  const [company, setCompany] = useState("");
  const [display, setDisplay] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (code.length >= 4) fetch(`${API}/invite/${code}`).then((r) => r.json()).then((d) => { if (d.valid) setCompany(d.company_name); }).catch(() => {});
  }, [code]);

  const submit = async () => {
    setErr("");
    if (username.length < 3 || password.length < 4 || !display) { setErr(tr("join.errFields")); return; }
    setBusy(true);
    try {
      const res = await fetch(`${API}/auth/join`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ code, username, password, display_name: display }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.detail || tr("join.joinFailed"));
      setToken(data.access_token); await refresh(); nav("/dashboard");
    } catch (e) { setErr(e?.message || tr("join.joinFailed")); } finally { setBusy(false); }
  };

  return (
    <div className="screen fade-up" style={{ padding: 24 }}>
      <div style={{ width: 72, height: 72, borderRadius: 18, background: C.amber, display: "flex", alignItems: "center", justifyContent: "center" }}><Icon name="people" size={36} color={C.black} /></div>
      <h1 className="display" style={{ color: C.text, fontSize: 30, fontWeight: 900, marginTop: 16 }}>{tr("join.title")}</h1>
      {!!company && <div style={{ color: C.green, fontWeight: 800, marginBottom: 12 }}>{tr("join.joining")} {company}</div>}
      <Field label={tr("join.inviteCode")} testID="join-code" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="ABCD1234" />
      <Field label={tr("join.yourName")} testID="join-name" value={display} onChange={(e) => setDisplay(e.target.value)} />
      <Field label={tr("join.username")} testID="join-username" autoCapitalize="none" value={username} onChange={(e) => setUsername(e.target.value)} />
      <Field label={tr("join.passwordPin")} testID="join-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      {!!err && <div style={{ color: C.red, marginBottom: 12, fontWeight: 600 }}>{err}</div>}
      <Button title={tr("join.joinTeam")} testID="join-submit" onPress={submit} loading={busy} />
      <button className="pressable" onClick={() => nav("/login")} style={{ display: "block", margin: "12px auto 0", color: C.amber, fontWeight: 700 }}>{tr("join.backToLogin")}</button>
    </div>
  );
}
